//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ContactPractitioners from '~/mixins/contact/practitioners.js'

export default {
  mixins: [ContactPractitioners],
  data () {
    return {
      form: {
        fields: {
          firstName: {
            value: ''
          },
          lastName: {
            value: ''
          },
          email: {
            value: '',
            type: 'email'
          },
          password: {
            value: '',
            type: 'password'
          }
        }
      }
    }
  },
  computed: {
    textFields () {
      return this.$t('practitioners.contactForm.form.textFields')
    }
  },
  methods: {
    async onSubmit () {
      const slackText = Object.keys(this.form.fields).reduce((accum, current) => `${accum}${current}: ${this.form.fields[current].value}\n`, '')
      const data = {
        blocks: [
          {
            type: 'header',
            text: {
              type: 'plain_text',
              text: 'Company form submited'
            }
          },
          {

            type: 'context',
            elements: [
              {
                type: 'mrkdwn',
                text: slackText
              }
            ]
          }
        ]
      }
      await this.sendPractitionersContactForm(data)
      Object.keys(this.form.fields).forEach((field) => {
        this.form.fields[field].value = ''
      })
      this.$emit('showCalendly')
    }
  }
}
